import type { JSX } from 'react';

import type { ErrorHandlerProps } from 'src/app/pages/local/pageContext';

export function LocalErrorHandler({ context: { error } }: ErrorHandlerProps): JSX.Element {
	throw new Error(`Failed to retrieve data for Local page (error: ${error})`);
}
